import { useEffect, useMemo } from 'react';
import type { GamePlayerProjectionTrading } from '@library/types/trading';
import { useImmer } from 'use-immer';

export function useTrackFinalizeProjections({
  setProposedProjections
}: {
  setProposedProjections: (
    proposedProjections: Array<GamePlayerProjectionTrading>
  ) => void;
}): {
  updateProjection: ({
    change,
    initialProjection
  }: {
    change: GamePlayerProjectionTrading;
    initialProjection: GamePlayerProjectionTrading;
  }) => void;
  newAndChangedProjections: Array<GamePlayerProjectionTrading>;
} {
  const [newAndChangedProjections, setNewAndChangedProjections] = useImmer<
    Array<GamePlayerProjectionTrading>
  >([]);

  useEffect(() => {
    setProposedProjections(
      newAndChangedProjections.filter(
        (projection) => projection.status !== 'removed'
      )
    );
  }, [newAndChangedProjections, setProposedProjections]);

  const updateProjection = useMemo(
    () =>
      ({
        change,
        initialProjection
      }: {
        change: GamePlayerProjectionTrading;
        initialProjection: GamePlayerProjectionTrading;
      }) => {
        const { projectionId } = initialProjection;

        setNewAndChangedProjections((draft) => {
          const affectedProjectionIndex = draft.findIndex(
            (projection) => projection.projectionId === projectionId
          );

          if (affectedProjectionIndex === -1) {
            draft.push(change);

            return;
          }

          draft[affectedProjectionIndex] = {
            ...draft[affectedProjectionIndex],
            ...change
          };
        });
      },
    [setNewAndChangedProjections]
  );

  return {
    newAndChangedProjections,
    updateProjection
  };
}
